import { render, staticRenderFns } from "./EditStylingButton.vue?vue&type=template&id=dd2a099e&"
import script from "./EditStylingButton.vue?vue&type=script&lang=js&"
export * from "./EditStylingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports